module.exports = __webpack_public_path__ + "img/status-report-badge-5.3426b5eb.svg";